<template>
	<div class="body">
		<bg></bg>
		<div class="main">
			<div class="head">
				<h1>运营管理平台</h1>
				<p>OPERATIONAL MANAGEMENT SYSTEM</p>
			</div>
			<div class="login">
				<div class="logo flex-center" :style="{'background-image': `url('${systemConfig.oms_login_logo}')`}"></div>
				<p class="title">登录中心</p>
				<form @submit.prevent="login">
					<div class="item flex">
						<i class="flex-center tf tf-username"></i>
						<input v-model="username" class="flex-grow" type="text" placeholder="请输入用户名">
					</div>
					<div class="item flex">
						<i class="flex-center tf tf-password"></i>
						<input v-model="password" class="flex-grow" type="password" placeholder="请输入密码">
					</div>
					<c-button width="320" height="44" radius="22" font-size="18">登录</c-button>
				</form>
				<p class="copyright">{{systemConfig.oms_copyright}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	import bg from './bg.vue'
	import CryptoJs from '@/assets/script/lib/crypto-js'
	import validate from '@/assets/script/validate.js'
	import {mapState} from 'vuex'
	
	export default {
		components: {
			bg
		},
		
		data() {
			return {
				username: '',
				password: ''
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
		},

		methods: {
			login() {
				validate({
					user_name: this.username.trim(),
					user_pwd: this.password.trim()
				}, {
					rule: {
						user_name: [{
							type: 'empty',
							word: '请输入用户名'
						}],
						user_pwd: [{
							type: 'empty',
							word: '请输入密码'
						}]
					},
					success: data => {
						data.user_pwd = CryptoJs.MD5(data.user_pwd).toString();
						
						this.request({
							url: '/sys_user/login',
							data: data,
							loading: true,
							success: data => {
								this.$store.commit('setSession', data.user_info.session);
								this.$store.commit('setUserInfo', data.user_info);
								this.$store.commit('setNav', data.user_menu_list[0] ? data.user_menu_list[0].child_menu_list : []);
								this.$store.commit('setPowers', Array.from(data.user_menu_key_list, item => item.menu_unique_key));
								this.navigateTo('/');
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.body {
		height: 100vh;
		background: #222;
		theme-background(main);

		.main {
			position: fixed;
			left: 50%;
			top: 50%;
			width: 430px;
			overflow: hidden;
			transform: translate(-50%, -50%);
			
			.head {
				text-align: center;
				color: #fff;
				
				h1 {
					font-size: 30px;
					font-weight: normal;
				}
				
				p {
					margin-top: 12px;
					font-size: 12px;
					opacity: .6;
				}
			}
			
			.login {
				position: relative;
				box-sizing: border-box;
				height: 320px;
				border-radius: 6px;
				padding: 48px 55px 0;
				margin-top: 58px;
				background: #fff;
				
				.logo {
					position: absolute;
					left: 50%;
					top: -35px;
					width: 70px;
					height: 70px;
					border-radius: 100%;
					margin-left: -35px;
					overflow: hidden;
					background-size: cover;
				}
				
				.title {
					margin-bottom: 26px;
					font-size: 20px;
					text-align: center;
				}

				.item {
					height: 36px;
					border: 1px solid #eee;
					margin-bottom: 12px;
					transition: all .2s ease;

					&:hover,
					&:focus-within {
						border-color: #ccc;
						
						.tf {
							border-color: #ccc;
						}
					}

					.tf {
						width: 40px;
						height: 100%;
						border-right: 1px solid #eee;
						font-size: 18px;
						color: #000;
						background: #F5F5F5;
					}

					input {
						box-sizing: border-box;
						height: 100%;
						padding: 0 12px;
						border: none;
					}
				}
				
				.c-button {
					margin-top: 20px;
				}
				
				.copyright {
					margin-top: 26px;
					font-size: 12px;
					text-align: center;
					color: #999;
				}
			}
		}

		.code {
			p {
				margin: 70px 0 28px;
				font-size: 18px;
				font-weight: bold;
			}

			form {
				position: relative;
				overflow: hidden;

				input {
					width: 310px;
					height: 48px;
					padding: 0 10px;
					border: 1px solid #ddd;
					border-radius: 4px 0 0 4px;
					transition: all .2s ease;

					&:focus {
						border-color: #2F7BFF;
					}
				}

				span {
					position: absolute;
					right: 100px;
					top: 50%;
					font-size: 13px;
					color: #2F7BFF;
					transform: translate(0, -50%);
					cursor: pointer;

					&.z-dis {
						color: #999;
					}
				}

				button {
					width: 90px;
					height: 50px;
					border-radius: 0 4px 4px 0;
				}
			}
		}
	}
</style>
